import { Link } from 'react-router-dom';
import FeatherIcon from 'feather-icons-react';

const NoRolesScreenForm = () => {
  return (
    <div className="text-center mb-5">
      <FeatherIcon
        icon="alert-circle"
        size={48}
        className="text-warning mb-3"
      />
      <h4 className="mb-3">Access Pending</h4>
      <p className="mb-4">
        Your account has been created successfully, but you don't have any roles
        assigned yet. Please contact your system administrator to request the
        appropriate roles for your account.
      </p>
      <div className="fs-9 mb-4">
        After roles are assigned, you can try logging in again.
      </div>
      <Link to="/authentication/sign-in" className="btn btn-primary">
        Back to Login
      </Link>
    </div>
  );
};

export default NoRolesScreenForm;
